import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { NeglectedOrDelinquentInformationFormValues } from '../../../types/NeglectedOrDelinquentInformationModel';
import { PanelType } from '../../../types/PanelType';
import { createNeglectedOrDelinquentInformationValidationSchema } from '../../../types/Validation/NeglectedOrDelinquentInformationValidationSchema';
import FormInputLabel from '../../FormInputs/FormInputLabel/FormInputLabel';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';

const NeglectedOrDelinquentStudentPopulationPanel = ({
    disabled,
    validationSchema,
}: {
    disabled: boolean;
    validationSchema: ReturnType<
        typeof createNeglectedOrDelinquentInformationValidationSchema
    >;
}): ReactElement => {
    const { values, errors } =
        useFormikContext<NeglectedOrDelinquentInformationFormValues>();
    const students = Number(values.unduplicatedStudentsServed);
    const days = Number(values.totalYearlyLengthOfStayDays);
    const canCalculate = values.unduplicatedStudentsServed !== ''
        && values.totalYearlyLengthOfStayDays !== ''
        && !errors.unduplicatedStudentsServed && !errors.totalYearlyLengthOfStayDays;
    let average: number | '' = '';
    if (canCalculate) average = students === 0 ? 0 : Math.round(days / students);

    return (
        <Panel panelType={PanelType.INFO} heading="Student Population">
            <p>Provide the <strong>number of students:</strong></p>
            <div className="field-row nord-student-population">
                <FormTextbox
                    field="unduplicatedStudentsServed"
                    validationSchema={validationSchema}
                    displayName="Unduplicated Students Served"
                    disabled={disabled}
                />
                <FormTextbox
                    field="totalYearlyLengthOfStayDays"
                    validationSchema={validationSchema}
                    displayName="Total Yearly Length of Stay (Days)"
                    disabled={disabled}
                />
                <div className="field-container disabled">
                    <FormInputLabel
                        field="averageLengthOfStayDays"
                        displayName="Average Length of Stay (Days)"
                        disabled
                    />
                    <input
                        id="averageLengthOfStayDays"
                        className="data-input"
                        type="text"
                        disabled
                        readOnly
                        value={average}
                    />
                </div>
            </div>
        </Panel>
    );
};

export default NeglectedOrDelinquentStudentPopulationPanel;
